import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

import { PrivaHeaderComponent } from '@priva/components/header';
import { PrivaTitleSize } from '@priva/components/title';
import { PrivaTheme } from '@priva/styles/foundation';

import { ErrorMessage, HttpErrorHandlingService } from 'shared/error-handling';

import { ReportUnsubscribeService } from './report-unsubscribe';
import { Unsubscribe } from './unsubscribe.model';

@Component({
    selector: 'analytics-unsubscribe',
    templateUrl: './unsubscribe.component.html',
    // eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [PrivaHeaderComponent, AsyncPipe, TranslatePipe],
})
export class UnsubscribeComponent implements OnInit {
    unsubscribe$: Observable<Unsubscribe>;
    errorObject: ErrorMessage;

    statusMessageHeaderSize = PrivaTitleSize.Lg;
    statusMessageHeaderTheme = PrivaTheme.OnLightGray;

    constructor(
        private readonly route: ActivatedRoute,
        private readonly reportUnsubscribeService: ReportUnsubscribeService,
        private readonly httpErrorHandlingService: HttpErrorHandlingService,
    ) {}

    ngOnInit(): void {
        this.unsubscribe$ = this.route.paramMap.pipe(
            switchMap((params: ParamMap) => {
                return this.reportUnsubscribeService.unsubscribe(params.get('subscriptionId')).pipe(
                    catchError((error: any) => {
                        this.errorObject = this.httpErrorHandlingService.getErrorMessageObject(error);

                        return of(null);
                    }),
                );
            }),
        );
    }
}
